import { Component } from '@angular/core';
import { ViewController } from 'ionic-angular';
import { SigninService } from './../../services/signin.service';
import { AppConfig } from '../../app/app.config';

@Component({
    selector: 'realm',
    templateUrl: 'realm.html',
    providers: [SigninService]
})
export class Realm {
    autourl = [];
    constructor(
        private signinService: SigninService,
        private ViewCtrl: ViewController,
        private config: AppConfig,
    ) {
        this.geturls();
    }

    //获取线路列表
    //TQQ 2017-03-16
    geturls() {
        this.signinService.getping().then(s => {
            if (s) {
                this.autourl = [];
                for (var i = 0; i < s.length; i++) {
                    this.autourl.push({ "name": "线路" + (i + 1), "url": s[i], "time": "0", "timenum": 0 });
                }
            }
            this.autourl.forEach(u => {
                this.signinService.ping({
                    url: u.url,
                    interval: 60,
                    afterPing: function (ping) {
                        u.time = ping >= 3000 ? ">3s" : ping / 2 > 300 ? ">300ms" : parseInt((ping / 2).toString()) + "ms";
                        u.timenum = ping;
                    }
                }).then(() => {
                    Promise.all(this.autourl).then(() => {
                        this.autourl = this.autourl.sort((a, b) => { return a.timenum - b.timenum });
                    });
                });
            });

        });
    }


    //访问某线路
    //chen 2017-03-15
    visit(obj) {
        this.config.openUrl(obj.url);
    }

    //返回
    //chen 2017-03-15
    close() {
        this.ViewCtrl.dismiss();
    }

}




// WEBPACK FOOTER //
// ./src/pages/signin/realm.ts